import React from "react";

import VideoCard from "../cards/videoCard";

import BackFlower from "images/illustrations/back-flower.inline.svg";

const TextPageVideoGallery = ({
  galleryList,
  mobileScroll = false,
  galleryContainerClass = "relative w-full bg-gray-lighten planet:bg-gray-darker overflow-hidden text-gallery-section"
}) => {
  return (
    <>
      <section className={galleryContainerClass}>
        <BackFlower className="hidden planet:md:block absolute -left-[10%] -bottom-1/2 stroke-white" />
        <div className="w-11/12 md:w-9/12 mx-auto py-20 pt-10 md:pt-20">
          <h1
            className="title font-normal planet:font-light"
            dangerouslySetInnerHTML={{ __html: galleryList?.title }}
          />

          {galleryList?.subtitle && (
            <h3
              className="title font-normal planet:font-light leading-1 w-full sm:pr-5"
              dangerouslySetInnerHTML={{ __html: galleryList?.subtitle }}
            />
          )}
          <div className="spacer pb-10 md:pb-16" />

          <div className="flex flex-col md:flex-row w-full max-h-[170vw] md:max-h-[auto] pr-5 !pb-0 md:pr-0 overflow-y-auto md:overflow-visible gvi-scrollbar-thin masked-overview masked-overview-down md:masked-overview_disable">
            <div className="w-full md:w-2/3 pb-4 md:pb-0 md:pr-5">
              <VideoCard
                featVideos={galleryList?.videos[0]?.genVideoUrl}
                active={true}
                cardClass="mr-1 sm:mr-0 h-48 sm:h-auto bg-cover bg-no-repeat bg-center relative planet:bg-gray-dark"
              />
            </div>

            <div className="relative w-full md:w-1/3">
              <div className="md:absolute w-full md:h-full md:overflow-scroll md:pr-6 md:gvi-scrollbar-thin">
                {galleryList?.videos?.slice(1, 10).map((videoUrl, idx) => {
                  const useVideo = videoUrl.genVideoUrl;
                  return (
                    <div
                      className={`mb-4 planet:bg-gray-dark rounded-xs ${
                        mobileScroll ? "" : "hidden md:block"
                      } col-span-2 sm:col-span-1`}
                      key={`gallery-video-item-${idx}`}
                    >
                      <VideoCard
                        featVideos={useVideo}
                        cardClass={`${
                          idx === 1 ? "ml-1 sm:ml-0" : ""
                        }  h-48 sm:h-full bg-cover bg-no-repeat bg-center`}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TextPageVideoGallery;
